"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    badgeVariants: ()=>badgeVariants,
    badgePalettes: ()=>badgePalettes,
    badgeEmphases: ()=>badgeEmphases,
    badgeSizes: ()=>badgeSizes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const badgeVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        badgeSlot: 'inline-flex items-center rounded-full antialiased',
        textSlot: 'transition',
        iconSlot: 'inline-block transition',
        imageSlot: 'mb-1 ml-1 mt-1 flex-shrink-0 overflow-hidden',
        imageImg: 'h-full w-full rounded-[2px] object-cover'
    },
    variants: {
        palette: {
            neutral: {},
            benefit: {},
            customer: {},
            highlight: {},
            urgency: {},
            error: {},
            success: {},
            caution: {},
            marketingBrand: {},
            promoPrimary: {}
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        },
        size: {
            sm: {
                badgeSlot: 'min-h-5 px-1 py-0.5',
                textSlot: 'text-body3 mx-1',
                iconSlot: 'h-[16px] w-[16px]',
                imageSlot: 'h-[14px] w-[14px]'
            },
            md: {
                badgeSlot: 'min-h-6 px-1 py-0.5',
                textSlot: 'text-body2 mx-1',
                iconSlot: 'h-[20px] w-[20px]',
                imageSlot: 'h-[14px] w-[14px]'
            }
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-neutral-3',
                textSlot: 'text-neutral-11',
                iconSlot: 'text-neutral-8'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-benefit-3',
                textSlot: 'text-benefit-11',
                iconSlot: 'text-benefit-8'
            }
        },
        {
            palette: 'customer',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-customer-3',
                textSlot: 'text-customer-11',
                iconSlot: 'text-customer-8'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-highlight-3',
                textSlot: 'text-highlight-11',
                iconSlot: 'text-highlight-8'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-urgency-3',
                textSlot: 'text-urgency-11',
                iconSlot: 'text-urgency-8'
            }
        },
        {
            palette: 'error',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-error-3',
                textSlot: 'text-error-11',
                iconSlot: 'text-error-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-caution-3',
                textSlot: 'text-caution-11',
                iconSlot: 'text-caution-9'
            }
        },
        {
            palette: 'success',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-success-3',
                textSlot: 'text-success-11',
                iconSlot: 'text-success-8'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-marketingBrand-3',
                textSlot: 'text-marketingBrand-11',
                iconSlot: 'text-marketingBrand-8'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'medium',
            class: {
                badgeSlot: 'bg-promoPrimary-3',
                textSlot: 'text-promoPrimary-11',
                iconSlot: 'text-promoPrimary-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-neutral-1',
                textSlot: 'text-neutral-11',
                iconSlot: 'text-neutral-11'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-benefit-1',
                textSlot: 'text-benefit-11',
                iconSlot: 'text-benefit-11'
            }
        },
        {
            palette: 'customer',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-customer-1',
                textSlot: 'text-customer-11',
                iconSlot: 'text-customer-11'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-highlight-1',
                textSlot: 'text-highlight-11',
                iconSlot: 'text-highlight-11'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-urgency-1',
                textSlot: 'text-urgency-11',
                iconSlot: 'text-urgency-11'
            }
        },
        {
            palette: 'error',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-error-1',
                textSlot: 'text-error-11',
                iconSlot: 'text-error-11'
            }
        },
        {
            palette: 'success',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-success-1',
                textSlot: 'text-success-11',
                iconSlot: 'text-success-11'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-caution-1',
                textSlot: 'text-caution-11',
                iconSlot: 'text-caution-8'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-marketingBrand-1',
                textSlot: 'text-marketingBrand-11',
                iconSlot: 'text-marketingBrand-8'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'regular',
            class: {
                badgeSlot: 'bg-promoPrimary-1',
                textSlot: 'text-promoPrimary-11',
                iconSlot: 'text-promoPrimary-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-neutral-8',
                textSlot: 'text-neutral-1',
                iconSlot: 'text-neutral-1'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-benefit-8',
                textSlot: 'text-benefit-1',
                iconSlot: 'text-benefit-1'
            }
        },
        {
            palette: 'customer',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-customer-8',
                textSlot: 'text-customer-1',
                iconSlot: 'text-customer-1'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-highlight-8',
                textSlot: 'text-highlight-1',
                iconSlot: 'text-highlight-1'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-urgency-8',
                textSlot: 'text-urgency-1',
                iconSlot: 'text-urgency-1'
            }
        },
        {
            palette: 'error',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-error-8',
                textSlot: 'text-error-1',
                iconSlot: 'text-error-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-caution-7',
                textSlot: 'text-caution-11',
                iconSlot: 'text-caution-12'
            }
        },
        {
            palette: 'success',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-success-8',
                textSlot: 'text-success-1',
                iconSlot: 'text-success-1'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-marketingBrand-8',
                textSlot: 'text-marketingBrand-1',
                iconSlot: 'text-marketingBrand-1'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'bold',
            class: {
                badgeSlot: 'bg-promoPrimary-8',
                textSlot: 'text-promoPrimary-1',
                iconSlot: 'text-promoPrimary-1'
            }
        }
    ],
    defaultVariants: {
        palette: 'neutral',
        emphasis: 'medium',
        size: 'sm'
    }
});
const badgeSizes = Object.keys(badgeVariants.variants.size);
const badgePalettes = Object.keys(badgeVariants.variants.palette);
const badgeEmphases = Object.keys(badgeVariants.variants.emphasis);
exports.badgeEmphases = __webpack_exports__.badgeEmphases;
exports.badgePalettes = __webpack_exports__.badgePalettes;
exports.badgeSizes = __webpack_exports__.badgeSizes;
exports.badgeVariants = __webpack_exports__.badgeVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "badgeEmphases",
    "badgePalettes",
    "badgeSizes",
    "badgeVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
